import React from 'react';
import './ReviewFilterTabs.css';

const ReviewFilterTabs = ({ activeFilter, onFilterChange, rating }) => {
  const filters = [
    { value: 'all', label: 'All Reviews', count: rating.totalReviews },
    { value: '5star', label: '5 Star', count: rating.distribution[5].count },
    { value: '4star', label: '4 Star', count: rating.distribution[4].count },
    { value: '3star', label: '3 Star', count: rating.distribution[3].count },
    { value: '2star', label: '2 Star', count: rating.distribution[2].count },
    { value: '1star', label: '1 Star', count: rating.distribution[1].count },
    { value: 'withPhotos', label: 'With Photos', count: null },
    { value: 'reported', label: 'Reported', count: null }
  ];

  return (
    <div className="review-filter-tabs">
      <div className="filter-tabs-container">
        {filters.map(filter => (
          <button
            key={filter.value}
            className={`filter-tab ${activeFilter === filter.value ? 'active' : ''}`}
            onClick={() => onFilterChange(filter.value)}
          >
            <span>{filter.label}</span>
            {filter.count !== null && (
              <span className="filter-badge">{filter.count}</span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ReviewFilterTabs;

